module.exports = __webpack_public_path__ + "static/media/Swis721_BT.4587a81c.woff2";